(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sales-opportunity"] && !Shopify.designMode) return;
  try {
    
  function focusSalesConfirmation(root) {
    const params = new URLSearchParams(window.location.search);
    const campaign = root.querySelector("[data-sales-campaign]");
    const source = root.querySelector("[data-sales-source]");
    if (campaign) campaign.value = (params.get("utm_campaign") || "").slice(0,200);
    if (source) source.value = [params.get("utm_source"), params.get("utm_medium")].filter(Boolean).join(" / ").slice(0,200);

    const confirmation = root.querySelector('[data-sales-confirmation="received"]');
    if (!confirmation) return;
    confirmation.focus({ preventScroll: true });
    confirmation.scrollIntoView({ block: 'start', behavior: 'instant' });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => focusSalesConfirmation(document), { once: true });
  } else {
    focusSalesConfirmation(document);
  }
  document.addEventListener('shopify:section:load', event => focusSalesConfirmation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-header"]) return;
  try {
    
document.querySelectorAll(".site-nav [data-menu]").forEach((link) => {
  link.addEventListener("keydown", (event) => {
    if (event.key !== "ArrowDown" && event.key !== " ") return;
    const trigger = document.querySelector(`.site-menu-root button[data-menu="${link.dataset.menu}"]`);
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
  });
});

  } catch(e) { console.error(e); }
})();
})();
